/**
 * Snow Monkey Forms
 * 郵便番号 → 住所 自動入力
 */

export function smf_auto_zipaddr() {

  const FORM_SEL = '.snow-monkey-form';
  const ZIP_SEL = 'input[name="zip"], input#zip';
  const ADDRESS_SEL = 'input[name="address"], input#address';

  const toHalf = (value) => {
    return String(value || '').replace(/[０-９－ー―-]/g, (char) => {
      const map = {
        '－': '-',
        'ー': '-',
        '―': '-',
        '-': '-',
      };

      if (char in map) {
        return map[char];
      }

      const code = char.charCodeAt(0);
      return code >= 0xff10 && code <= 0xff19 ? String(code - 0xff10) : char;
    });
  };

  const onlyDigits = (value) => {
    return toHalf(value).replace(/[^0-9]/g, '');
  };

  const toDashedZip7 = (digits) => {
    const zip = String(digits || '').slice(0, 7);
    return zip.length === 7 ? `${zip.slice(0, 3)}-${zip.slice(3)}` : zip;
  };

  const debounce = (callback, delay = 350) => {
    let timer;

    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        callback(...args);
      }, delay);
    };
  };

  async function lookupZip(zip7) {
    const response = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zip7}`, {
      credentials: 'omit',
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const json = await response.json();

    if (json.status !== 200 || !json.results || !json.results[0]) {
      throw new Error(json.message || '住所が見つかりませんでした。');
    }

    return json.results[0];
  }

  function fillAddress(addressEl, data) {
    if (!addressEl || !data) return;

    addressEl.value = `${data.address1 || ''}${data.address2 || ''}${data.address3 || ''}`;
    addressEl.dispatchEvent(new Event('input', { bubbles: true }));
    addressEl.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function findAddressPartner(zipEl) {
    const form = zipEl.closest(FORM_SEL) || document;
    return form.querySelector(ADDRESS_SEL);
  }

  function bindZip(zipEl) {

    if (!zipEl || zipEl.dataset.zipAutofillBound === 'true') return;

    const addressEl = findAddressPartner(zipEl);

    if (!addressEl) return;

    zipEl.dataset.zipAutofillBound = 'true';
    zipEl.setAttribute('inputmode', 'numeric');
    zipEl.setAttribute('autocomplete', 'postal-code');

    const run = debounce(async () => {
      const digits = onlyDigits(zipEl.value);

      if (digits.length >= 7) {
        const dashedZip = toDashedZip7(digits);

        if (zipEl.value !== dashedZip) {
          zipEl.value = dashedZip;
          zipEl.dispatchEvent(new Event('input', { bubbles: true }));
          zipEl.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      if (digits.length !== 7) return;
      if (zipEl.dataset.prevZip7 === digits) return;

      zipEl.setAttribute('aria-busy', 'true');

      try {
        const data = await lookupZip(digits);
        fillAddress(addressEl, data);
        zipEl.dataset.prevZip7 = digits;
      } catch (error) {
        console.debug('[zip autofill] failed:', error);
      } finally {
        zipEl.removeAttribute('aria-busy');
      }
    });

    zipEl.addEventListener('input', run);
    zipEl.addEventListener('change', run);
    zipEl.addEventListener('paste', () => {
      setTimeout(run, 0);
    });
  }

  function setup(scope = document) {
    const form = scope.querySelector(FORM_SEL) || scope;

    form.querySelectorAll(ZIP_SEL).forEach((zipEl) => {
      bindZip(zipEl);
    });
  }

  setup();

  const form = document.querySelector(FORM_SEL);

  if (form) {
    const observer = new MutationObserver(() => {
      setup(form);
    });

    observer.observe(form, {
      attributes: true,
      attributeFilter: ['data-screen', 'data-invalid'],
      childList: true,
      subtree: true,
    });
  }
}
